import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routesP = [
    {
    path: '/',
    name: 'Index',
    component: () => import( /* webpackChunkName: “about” */ '../views/pc/index.vue')
    }
    ]

const routesM = [{
path: '/',
name: 'Index',
component: () => import( /* webpackChunkName: “about” */ '../views/mobile/home/index.vue')
},{
    path: '/consultation',
    name: 'Consultation',
    component: () => import( /* webpackChunkName: “about” */ '../views/mobile/consultation/index.vue')
    }]

var routes = [];
if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
    routes = routesM
} else {
    routes = routesP
}



const router = new VueRouter({
mode: 'history',
base: process.env.BASE_URL,
routes
})

export default router
